import { render } from "./boardEntire.vue?vue&type=template&id=d3d22788&ts=true"
import script from "./boardEntire.vue?vue&type=script&lang=ts&config=true"
export * from "./boardEntire.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__